<template>
  <div class="dashboard">
    <Loader :loading="loading" loading-text="please wait..." />
    <main class="page-content">
      <header class="welcome-text mb-3 ml-2 ml-lg-0">
        Loan Request -
        <span class="transfer-option">Collateral Information</span>
      </header>

      <div class="statement-container">
        <!-- back-home -->
        <div class="back-home" style="cursor:pointer" @click="$router.go(-1)">
          <span>
            <i class="fal fa-long-arrow-left icon"></i>
          </span>
          <!-- <span><i class="fal fa-arrow-left icon fa-2x"></i></span> -->
        </div>

        <!-- form start -->
        <h6>Collateral Information</h6>

        <div class="mt-5">
          <ValidationObserver v-slot="{ passes }">
            <form @submit.prevent="passes(createAccount)">
              <div class="containe">
                <div class="row">
                  <div class="col-md-12">
                    <div class="row">
                      <!-- TYPE of collateral -->
                      <div class="col-md-5 mb-3">
                        <ValidationProvider name="typeCollateral" v-slot="{ errors }">
                          <label for="v">Type of Collateral</label>
                          <select
                            v-model="typeCollateral"
                            class="browser-default custom-select mb-3 mb-sm-0"
                            placeholder="collateral"
                            name="collateral"
                            id="type"
                          >
                            <option value="type">Type</option>
                            <option value="type">Type</option>
                            <option value="type">Type</option>
                          </select>
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                      <div class="col-md-1"></div>
                      <div class="col-md-5 mb-3">
                        <ValidationProvider name="nameCollateral" v-slot="{ errors }">
                          <label for="v">Name of Collateral</label>
                          <select
                            v-model="nameCollateral"
                            class="browser-default custom-select mb-3 mb-sm-0"
                            placeholder="collateral"
                            name="collateral"
                            id="name"
                          >
                            <option value="name">Name of Collateral</option>
                            <option value="name">Name of Collateral</option>
                            <option value="name">Name of Collateral</option>
                          </select>
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                    </div>

                    <!-- model -->
                    <div class="row">
                      <div class="col-md-5 mb-3">
                        <ValidationProvider name="modelCollateral" v-slot="{ errors }">
                          <label for="v">Model</label>
                          <div class="input-group">
                            <input
                              type="text"
                              v-model="modelCollateral"
                              class="form-control"
                              placeholder
                              name="model"
                            />
                          </div>
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                      <div class="col-md-1"></div>
                      <!--Date of Purchase -->
                      <div class="col-md-5 mb-3">
                        <ValidationProvider name="purchaseDate" v-slot="{ errors }">
                          <label for="v">Purchase Date</label>
                          <div class="input-group">
                            <input
                              type="text"
                              v-model="PurchaseDate"
                              class="form-control"
                              placeholder
                              name="purchasedate"
                            />
                          </div>
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                    </div>

                    <!-- Current Value -->
                    <div class="row">
                      <div class="col-md-5 mb-3">
                        <ValidationProvider name="currentValue" v-slot="{ errors }">
                          <label for="v">Current Value</label>
                          <div class="input-group">
                            <input
                              type="text"
                              v-model="currentValue"
                              class="form-control"
                              placeholder
                              name="currentvalue"
                            />
                          </div>
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                      <!-- Account Number -->
                      <div class="col-md-6 mb-3"></div>
                    </div>
                  </div>
                </div>

                <div class="d-flex mt-3 justify-content-start">
                  <b-button
                    type="submit"
                    class="btn mt-3 text-center mr-1 btn-primary"
                    @click="showSubmit = true"
                  >Submit</b-button>
                  
                </div>
              </div>
            </form>
          </ValidationObserver>
          <!-- success modal -->
        <b-modal hide-footer v-model="showSubmit">
          <div class="modal-container text-center">
            <p class="welcome-text">Submitted Successfully</p>

            <div>
               <img
                src="../../../assets/images/payment-success.png"
                class="img-fluid"
                width="100px"
                alt
              /> 
            </div>

            <div>
              <button class="btn btn-primary px-4 mt-4" @click="modalShow = false">Continue</button>
            </div>
          </div>
        </b-modal>
        </div>
       </div>
    </main>
  </div>
</template>

<script>
//import VueNumeric from "vue-numeric";
import { clientService } from "../../../services/ClientServices/client.services";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Loader from "../../../utils/vue-loader/loader.vue";
//import { mapState } from "vuex";
export default {
  name: "Apply",
  components: {
    ValidationObserver,
    ValidationProvider,
    Loader,
    //VueNumeric
  },
  data() {
    return {
       typeCollateral: "",
      nameCollateral: "",
      modelCollateral: "",
      purchaseDate: "",
      currentValue: "",
      showSubmit: false,
      loading: false
    };
  },
  methods: {
    minus() {
      if (this.tenor <= 0) return;
      this.tenor = this.tenor - 1;
    },
    plus() {
      if (this.tenor >= 6) return;
      this.tenor = this.tenor + 1;
    },
    //Post Loan
    async postLoan() {
      this.loading = true;
      await clientService
        .postLoan({
          amount: this.amount,
          tenor: this.tenor,
          account: this.account,
          purpose: this.loanPurpose,
          bank: this.bank
        })
        .then(res => {
          this.$toastr.s(res.message, "Posted Succesfully");
          this.$router.push("/Loan");
        })
        .catch(err => {
          this.$toastr.e(err.message || err, "Failed!");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-primary {
  background: $main-color;
  border: 1px solid $main-color;
  font-family: $SourceSansPro-Regular;
  width: 100px;
}

.back-home {
  width: 170px;
}
</style>
